import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { FindLoad, FindSuccessItem, Images, useGlobalStyles, } from 'utils';
import {
  AddModalButton,
  CustomNumericFormat, Loader,
  NoYet,
  PriceRow,
  TextRow,
  ToastScreen,
  ValidationInput,
} from 'components';
import { customerPaymentActions, httpRequestsOnSuccessActions, loadActions } from 'store';
import { inputsStyle } from '../../../components/inputs/styles';
import { CollectRow } from '../../../pages/accounting/collections/core';
import { IN_TRANSIT, PROCESSING } from '../../../pages/accounting/constants';
import { loadStatusEnum } from '../../../pages';
import { useForm } from 'react-hook-form';

const LOAD_ACTION_TYPE = 'GET_LOADS_BY_STATUS';
const LOAD_CARRIER_ACTION_TYPE = 'GET_CARRIER_BY_ID';
const ACTION_TYPE = 'CREATE_CUSTOMER_PAYMENT_LOAD'
export const AddOrder = ({ }) => {
  const { customerPaymentById, customerPaymentLoad, loadsList } = useSelector((state) => ({
    customerPaymentById: state.customerPayments.customerPaymentById,
    customerPaymentLoad: state.customerPayments.customerPaymentLoad,
    loadsList: state.loads.loadsList,
  }));
  const classes = inputsStyle();
  const globalStyles = useGlobalStyles();
  const dispatch = useDispatch();
  const loadList = FindLoad(LOAD_ACTION_TYPE);
  const loader = FindLoad(ACTION_TYPE);
  const success = FindSuccessItem(ACTION_TYPE);
  const [error, setError] = useState('');
  const [dept, setDept] = useState(loadsList?.loads);
  const ref = useRef();
  const [loadId, setLoadId] = useState(null);
  const [saveId, setSaveId] = useState(null);
  const carrierLoad = FindLoad(LOAD_CARRIER_ACTION_TYPE);
  const loadAmount = customerPaymentById?.amount && (customerPaymentById?.amount - customerPaymentById?.used).toFixed(2);
  const { handleSubmit} = useForm({ mode: "onSubmit" });

  useEffect(() => {
    if(success){
      getLoads('noLoad');
      dispatch(httpRequestsOnSuccessActions.removeSuccess(ACTION_TYPE))
    }
  }, [success])

  useEffect(() => {
    getLoads('', false);
  }, []);

  const getLoads = (load, search) => {
    const params = {
      skip: 0,
      limit: 200,
      customer: customerPaymentById?.customerId,
      statuses: [loadStatusEnum.IN_TRANSIT, loadStatusEnum.PROCESSING, loadStatusEnum.PENDING_FLOAT]
    };

    if (search) {
      params.searchKey = 'LOAD_DISPLAY_ID';
      params.searchValue = loadId;
    } else {
      delete params?.searchKey;
      delete params?.searchValue;
    }
    dispatch(loadActions.getLoadsByStatus(params, load));
  };

  useEffect(() => {
    if (loadsList?.loads?.length) {
      const filteredList = loadsList?.loads?.filter(function (array_el) {
        return customerPaymentLoad?.filter(function (anotherOne_el) {
          return (anotherOne_el?.displayId === array_el?.displayId && anotherOne_el?.status === "APPLIED");
        }).length === 0
      });

      const params = filteredList?.map(item => {
        if (item?.bill?.balance > 0) {
          return {
            loadId: item?.id,
            amount: 0,
            description: item?.description ? item?.description  : '',
            displayId: item?.displayId,
            reserveAmount: 0,
            totalRate: item?.bill?.totalRate,
            balance: item?.bill?.balance,
          };
        }
        return null;
      }).filter(item => item !== null);

      setDept(params);
    } else {
      setDept([]);
    }
  }, [loadsList]);

  const handleChange = (value, name, item, index) => {
    // const sendParams = {
    //   loadId: item?.loadId,
    //   amount: item?.reserveAmount,
    //   description: item?.comment,
    //   customerPaymentId: customerPaymentById?.id,
    // }
    const params = [
      ...dept,
    ];
    params[index][name] = value;
    setDept(params);

    if (name === 'reserveAmount' && error === 'reserveAmount') {
      setError('');
    }
  };

  const handleCollect = () => {
    let amount = 0
    dept?.forEach((i) => amount = amount + i?.amount )
    if(loadAmount >= amount) {
      const list = dept?.filter(i => i?.amount > 0);
      dispatch(customerPaymentActions.createCustomerPaymentLoad({ loadPmts: list }, customerPaymentById?.id));
    }else{
      toast(<ToastScreen type="error" text="Entered amount is greater than the available amount." />);
    }
  };

  const handleSearch = () => {
    if (loadId) {
      setSaveId(loadId);
      getLoads('', true);
    } else {
      ref?.current?.focus();
    }
  };


  if (carrierLoad?.length) {
    return (
      <div className="collect-loads-modal" style={{height: 535}}>
        <Loader />
      </div>
    );
  }

  return (
    <div className="collect-loads-modal">
      <p className="collect-modal-title">Add Order</p>
      <div className="flex-align-start" style={{ gap: 16 }}>
        <div className='order-customer-box'>
          <p>Customer:</p>
          <div className='full-width'>
            <TextRow name={customerPaymentById?.customerName} />
          </div>
        </div>
        <CollectRow title="Available Amount:" value={+loadAmount} type={'price'} />
      </div>

      <form onSubmit={handleSubmit(handleSearch)}>
        <div className={classes.searchInputWrapper} style={{ width: '100%', margin: '16px 0 8px' }}>
          <input
            style={{ width: '100%', color: '#2A374E' }}
            ref={ref}
            type="search"
            onChange={(e) => {
              if (e?.target?.value === '' && saveId) {
                setSaveId('');
                setLoadId('');
                getLoads();
              } else {
                setLoadId(e?.target?.value);
              }
            }}
            placeholder={'Search by Load ID'}
            value={loadId}
          />
          <button onClick={handleSearch}>
            <img src={Images.searchIcon} alt={'icon'} />
          </button>
        </div>
      </form>

      <div className="collect-loads-table">
        <div className="collect-loads-table-head">
          <div style={{ width: '15%' }}>Load ID</div>
          <div style={{ width: '15%' }}>Total Amount</div>
          <div style={{ width: '15%' }}>Open Balance</div>
          <div style={{ width: '25%' }}>Paid Amount</div>
          <div style={{ width: '30%' }}>Description</div>
        </div>
        <div className="collect-loads-table-body">
          {loadList?.length ?
            <Loader height={'200px'} />
            :
            dept?.length ?
              dept?.map((i, j) => (
                <div key={j} className="collect-loads-table-body-row">
                  <div className="collect-loads-table-body-item" style={{ width: '15%' }}>
                    <TextRow name={i?.displayId} />
                  </div>
                  <div className="collect-loads-table-body-item" style={{ width: '15%' }}>
                    <PriceRow info={i?.totalRate} />
                  </div>
                  <div className="collect-loads-table-body-item" style={{ width: '15%' }}>
                    <PriceRow info={i?.balance} />
                  </div>
                  <div style={{ width: '25%' }}>
                    <CustomNumericFormat
                      noError={true}
                      // errorName={selectedId === i?.loadId && error}
                      error={error === 'amount'}
                      label={'Amount*'}
                      placeholder={'Enter Amount'}
                      name={'amount'}
                      value={i?.amount ? i?.amount : 0}
                      handleChangeMiles={(e) => handleChange(e?.floatValue, 'amount', i, j)}
                      // isAllowed={(values) => {
                      //   const { floatValue } = values;
                      //   const isValid = floatValue === undefined || (floatValue <= i?.balance);
                      //
                      //   if (!isValid && floatValue !== undefined) {
                      //     toast.dismiss();
                      //     toast(
                      //       <ToastScreen
                      //         type={'error'}
                      //         text={'Entered amount must be less than or equal to the available amount.'}
                      //       />,
                      //     );
                      //   }
                      //   return isValid;
                      // }}
                    />
                  </div>
                  <div style={{ width: '30%' }}>
                    <ValidationInput
                      noErrMessage={true}
                      style={globalStyles.simpleInputNoRight}
                      variant={'outlined'}
                      name={'description'}
                      type={'text'}
                      placeholder={'Write here...'}
                      onChange={(e) => handleChange(e?.target?.value, 'description', i, j)}
                      value={i?.description ? i?.description : ''}
                    />
                  </div>
                </div>
              ))
              :
              <NoYet position={'center'} text={'Not Yet'} />
          }
        </div>
      </div>

      <AddModalButton
        loading={!!loader?.length}
        handleClick={handleCollect}
        text={'Done'}
      />
    </div>
  );
};







